export default function Footer() {
  return (
    <footer className="w-full bg-gray-50 text-sm text-gray-600 px-4 py-6">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-4">
        {/* Left Side */}
        <div className="flex flex-wrap justify-center sm:justify-start items-center gap-1 text-center">
          <span>© 2025, made with</span>
          <span className="text-red-500 text-lg">❤️</span>
          <span>by</span>
          <a
            href="https://efsouls.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-brown-700 font-semibold hover:underline"
          >
            EFSOULS
          </a>
        </div>

        {/* Right Side */}
        <div className="text-brown-700 font-semibold text-center sm:text-right">
          Anuyog Admin
        </div>
      </div>
    </footer>
  );
}
